import React, { ReactElement, useMemo } from 'react';
import classNames from 'classnames';
import { useStyles } from './styles';
import { IssueStageProps, IssueStageSize } from './types';
import { useStage } from 'store/workflow';
import {
  getStageColorByIndex,
  getWorkflowStageDisplayName,
} from 'shared/domain/workflow/types';
import { sortByFractionalOrder } from 'helpers/sort';
import { compareObjectIds } from 'shared/utils/id/compare';

function IssueStage(props: IssueStageProps): ReactElement {
  const classes = useStyles();
  const { stageId, issueArchived, size } = props;

  const { stage, workflow } = useStage(stageId);

  const color = useMemo(() => {
    if (issueArchived || !stage || !workflow) {
      return undefined;
    }
    const sortedStages = [...workflow.stages].sort(sortByFractionalOrder);
    const stageIndex = sortedStages.findIndex((s) => compareObjectIds(s._id, stageId));
    return stageIndex >= 0
      ? getStageColorByIndex(stageIndex, sortedStages.length)
      : undefined;
  }, [stage, workflow, stageId, issueArchived]);

  return (
    <div
      className={classNames(
        classes.issueStatus,
        classes[size || IssueStageSize.small]
      )}
      style={color ? { color } : undefined}
    >
      {getWorkflowStageDisplayName(stage)}
    </div>
  );
}

export const MemoIssueStage = React.memo(IssueStage);
